import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import Popup from '../../Popup';
import styles from './index.styl';

const TermsAndPoliciesContent = ({ title, document, onClose }) => {
  return (
    <Popup opened onClose={onClose} title={title} width="medium">
      <div
        styleName="rootText"
        dangerouslySetInnerHTML={{ __html: document }}
      />
    </Popup>
  );
};

TermsAndPoliciesContent.propTypes = {
  title: PropTypes.string,
  document: PropTypes.node,
  onClose: PropTypes.func,
};

export default CSSModules(TermsAndPoliciesContent, styles, {
  allowMultiple: true,
});



// WEBPACK FOOTER //
// ./src/components/common/TermsAndPolicies/TermsAndPoliciesContent/index.jsx